<template>
    <div>
        <SearchBox ref="SearchBox">
            <el-form slot="form" :inline="true" ref="searchData" :model="searchParams" label-width="80px"
                     class="unitWidth" size="small">
                <el-form-item label="所属工厂">
                    <el-select v-model="fcIdSelected" placeholder="请选择" :clearable="isclear" filterable
                               :disabled="ischeck" @change="fcChange">
                        <el-option v-for="factory in factoryList" :key="factory.value" :label="factory.label"
                                   :value="factory.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="所属车间">
                    <el-select v-model="shopSelected" placeholder="请选择" clearable filterable @change="shopChange"
                               :disabled="scopeSelected == 'factory' || scopeSelected == 'company'">
                        <el-option v-for="shop in shopList" :key="shop.value" :label="shop.label"
                                   :value="shop.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="所属工段">
                    <el-select
                        v-model="sectionSelected"
                        placeholder="请选择"
                        clearable
                        filterable
                        @change="sectionChange"
                        :disabled="scopeSelected == 'shop' || scopeSelected == 'factory' || scopeSelected == 'company'"
                    >
                        <el-option v-for="section in sectionList" :key="section.value" :label="section.label"
                                   :value="section.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="所属产线">
                    <el-select
                        v-model="lineSelected"
                        placeholder="请选择"
                        clearable
                        filterable
                        @change="lineChange"
                        :disabled="scopeSelected == 'shop' || scopeSelected == 'factory' || scopeSelected == 'company' || scopeSelected == 'vsm'"
                    >
                        <el-option v-for="line in lineList" :key="line.value" :label="line.label"
                                   :value="line.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="设备编号">
                    <el-input v-model.trim="devCode" placeholder="请输入"></el-input>
                </el-form-item>
                <el-form-item label="设备名称">
                    <el-input v-model.trim="devName" placeholder="请输入"></el-input>
                </el-form-item>
                <el-form-item label="日期">
                    <el-date-picker style="width: 50vh" v-model="dateRange" type="daterange" range-separator="至"
                                    start-placeholder="开始日期" end-placeholder="结束日期" @change="searchTable">
                    </el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="searchTable">查询</el-button>
                </el-form-item>
            </el-form>
        </SearchBox>
        <LabelContent title="设备点检" ref="LabelContent">
            <div slot="btns">
                <!--                <el-button size="small" type="success" @click=";(ifAdd = true), updatehOpen()"> 新增</el-button>-->
                <!--                <el-button size="small" type="success" @click=";(ifAdd = true),updatehOpen()"> 新增</el-button>-->
                <!-- <el-button size="small" type="warning"> 批量移除</el-button> -->
                <el-button size="small" type="success" @click="onMailUser" v-for="acc in access" v-if="acc=='DAY0003'">
                    邮件
                </el-button>
                <el-button size="small" type="success" @click="exportDailyCheckOrder">导出</el-button>
            </div>
        </LabelContent>
        <div class="tableBox">
            <el-table stripe ref="multipleTable" :data="tableData" class="center">
                <!--                <el-table-column type="selection" width="55" />-->
                <el-table-column prop="fcName" label="所属工厂" width="160"/>
                <el-table-column prop="shopName" label="所属车间"/>
                <el-table-column prop="sectionName" label="所属工段" width="130px"/>
                <el-table-column prop="lineName" label="所属产线"/>
                <el-table-column prop="devName" label="设备名称"/>
                <el-table-column prop="devCode" label="设备编号" width="130px"/>
                <el-table-column prop="shiftDate" :formatter="dateFormat" label="班次日期" width="100px"/>
                <el-table-column prop="sfName" label="班次"/>
                <el-table-column prop="status" label="状态" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span>{{scope.row.status == true ? '完成' : '未完成'}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="singular" label="点检结果" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span>{{scope.row.singular == true ? '正常' : '异常'}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="dailyNumber" label="标准点检数" width="120"/>
                <el-table-column prop="dcoStatus" label="点检状态" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span>{{ scope.row.dcoStatus ? scope.row.dcoStatus.desc : ''}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="dcoRemarks" label="备注" width="120" show-overflow-tooltip/>
                <el-table-column prop="auditorPersonName" label="审核人" width="100" />
                <el-table-column prop="auditorTime" label="审核时间" width="150" />
                <el-table-column prop="compDailyNumber" label="完成点检数" width="120"/>
                <!--                <el-table-column prop="devRunTime" label="设备运行时长" show-overflow-tooltip />-->
                <!--                <el-table-column prop="devOtherTime" label="设备其他时间" show-overflow-tooltip />-->
                <!--                <el-table-column prop="isLastClean" label="设备故障时间" show-overflow-tooltip />-->
                <!--<el-table-column prop="isLastClean" label="上一班是否清洁" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span>{{scope.row.isLastClean == true?'已清洁':'未清洁'}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="isLube" label="是否润滑" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span>{{scope.row.isLube == true?'已润滑':'未润滑'}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="isCheck" label="是否检查" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span>{{scope.row.isCheck == true?'已检查':'未检查'}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="isClean" label="是否清洁" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span>{{scope.row.isClean == true?'已清洁':'未清洁'}}</span>
                    </template>
                </el-table-column>-->
                <el-table-column prop="startUserName" label="开班点检人" width="120"/>
                <el-table-column prop="shiftOfferStartTime" label="开班点检时间" width="160"/>
                <!--<el-table-column prop="endUserName" label="下班点检人" width="120" />
                <el-table-column prop="shiftCloseEndTime" label="下班点检时间" width="160" />
                <el-table-column prop="isNotUse" label="是否本班未使用" width="120">
                    <template slot-scope="scope">
                        <span>{{scope.row.isNotUse == true?'已使用':'未使用'}}</span>
                    </template>
                </el-table-column>-->
                <el-table-column label="操作" width="100" fixed="right">
                    <template slot-scope="scope">
                        <!--                        <i class="editBtn iconfont u-youjianbianji" @click=";(ifAdd = false), updatehOpen(scope.row)" />-->
                        <!--<i class="editBtn iconfont u-youjianbianji" @click=";(ifAdd = false),updatehOpen(scope.row)" />
                        <i class="delBtn iconfont u-shanchu" @click="deleteRow(scope.row)" />-->
                        <i class="document el-icon-more" @click="daliyCheckEditor(scope.row)" v-for="acc in access"
                           v-if="acc == 'DAY0001'"/>
                        <i class="delBtn iconfont u-shanchu" @click="deleteDaliyCheck(scope.row)" v-for="acc in access"
                           v-if="acc == 'DAY0002'"/>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                @size-change="paginationChange"
                @current-change="paginationCurrentChange"
                :current-page="searchParams.page"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="searchParams.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="searchParams.pageCount"
            />
        </div>
        <el-dialog title="日常点检每日提醒" :visible.sync="userMailShow" width="50%">
            <p style="color: red;margin-top: -2vw;text-align: left;margin-left: 1vw;">系统将每天早上7点，发送昨日点检完成情况，给以下人员。</p>
            <div style="text-align: left;text-align: left;margin-top: 1.5vw;">
                <div style="margin: 10px">
                    <el-select v-model="userSelected" size="small" filterable placeholder="请选择人员"
                               @change="userMailSelect"
                               style="margin-right: 20px">
                        <el-option
                            v-for="user in userListToSelect"
                            :key="user.userId"
                            :label="user.userName"
                            :value="user.userId">
                        </el-option>
                    </el-select>
                    <el-select v-model="workSelected" size="small" multiple filterable placeholder="请选择车间"
                               style="margin-right: 20px" collapse-tags>
                        <el-option
                            v-for="work in workShopList"
                            :key="work.shopCode"
                            :label="work.shopName"
                            :value="work.shopCode">
                        </el-option>
                    </el-select>
                    <el-button size="small" @click="onAndonUserSelectSubmit">选择提交</el-button>
                </div>
            </div>
            <div class="tableBox">
                <el-table stripe ref="multipleTable" :data="userAndonMailList" class="center">
                    <el-table-column prop="userName" label="用户"/>
                    <el-table-column prop="shopNames" label="车间"/>
                    <el-table-column label="操作" width="100" fixed="right">
                        <template slot-scope="scope">
                            <i class="editBtn iconfont u-youjianbianji" @click='editUserAndonMail(scope.row)'/>
                            <i class="delBtn iconfont u-shanchu" @click='onAndonMailUserDelete(scope.row)'/>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="userMailShow = false">关 闭</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import { getAllDailyCheckOrder } from '../../../libs/api'
    import moment from 'moment'

    export default {
        name: 'dailyCheckOrder',
        data() {
            return {
                searchParams: {
                    param: {},
                    pageSize: 10,
                    page: 1,
                    pageCount: 0
                },
                tableData: [],
                factoryTree: [],
                fcIdSelected: '',
                sectionSelected: '',
                shopSelected: '',
                lineSelected: '',
                userInfo: {},
                role: {},
                ischeck: true,
                scopeSelected: '',
                dcoId: '',
                devCode: '',
                devName: '',
                dateRange: '',
                access: [],
                scopeDisabled: '',
                isclear: false,
                dailyArray: {},
                userMailShow: false,
                userAndonMailList: [],
                userSelected: '',
                userMailList: [],
                userListToSelect: [],
                workSelected: [],
                workShopList: [],
            }
        },
        computed: {
            factoryList: function() {
                var arr = []
                var userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
                if (this.factoryTree != undefined && this.factoryTree.length > 0) {
                    if (this.ischeck) {
                        for (var i = 0; i < this.factoryTree.length; i++) {
                            for (let j = 0; j < userInfo.roles.length; j++) {
                                if (this.factoryTree[i].deptID == userInfo.roles[j].factoryId) {
                                    arr.push({
                                        label: this.factoryTree[i].deptName,
                                        id: this.factoryTree[i].deptID,
                                        value: JSON.stringify(this.factoryTree[i]),
                                        deptLevel: this.factoryTree[i].deptLevel,
                                        parent: 0
                                    })
                                }
                            }
                        }
                    } else {
                        for (var i = 0; i < this.factoryTree.length; i++) {
                            arr.push({
                                label: this.factoryTree[i].deptName,
                                id: this.factoryTree[i].deptID,
                                value: JSON.stringify(this.factoryTree[i]),
                                deptLevel: this.factoryTree[i].deptLevel,
                                parent: 0
                            })
                        }
                    }
                }
                return arr
            },
            shopList: function() {
                var arr = []
                if (this.fcIdSelected != undefined && this.fcIdSelected.length > 0) {
                    var factory = JSON.parse(this.fcIdSelected)
                    var shops = factory.child
                    for (var i = 0; i < shops.length; i++) {
                        if (shops[i].hasOwnProperty('deptCode')) {
                            arr.push({
                                label: shops[i].deptName,
                                id: shops[i].deptID,
                                value: JSON.stringify(shops[i]),
                                deptLevel: shops[i].deptLevel,
                                parent: 0
                            })
                        }
                    }
                }
                return arr
            },
            sectionList: function() {
                var arr = []
                if (this.shopSelected != undefined && this.shopSelected.length > 0) {
                    var shop = JSON.parse(this.shopSelected)
                    var vsms = shop.child
                    for (var i = 0; i < vsms.length; i++) {
                        if (vsms[i].hasOwnProperty('deptCode')) {
                            arr.push({
                                label: vsms[i].deptName,
                                id: vsms[i].deptID,
                                value: JSON.stringify(vsms[i]),
                                deptLevel: vsms[i].deptLevel,
                                parent: 0
                            })
                        }
                    }
                }
                return arr
            },
            lineList: function() {
                var arr = []
                if (this.sectionSelected != undefined && this.sectionSelected.length > 0) {
                    var vsm = JSON.parse(this.sectionSelected)
                    var lines = vsm.child
                    for (var i = 0; i < lines.length; i++) {
                        if (lines[i].hasOwnProperty('deptCode')) {
                            arr.push({
                                label: lines[i].deptName,
                                id: lines[i].deptID,
                                value: JSON.stringify(lines[i]),
                                deptLevel: lines[i].deptLevel,
                                parent: 0
                            })
                        }
                    }
                }
                return arr
            }
        },
        mounted() {
            this.access = JSON.parse(sessionStorage.getItem('auths'))
            this.init()
        },
        activated() {
            this.init()
        },
        methods: {
            init() {
                // this.userInfo = sessionStorage.getItem("userInfo")
                this.userInfo = this.$store.state.userInfo
                var role = this.userInfo.roles
                for (var i = 0; i < role.length; i++) {
                    //所有工厂数据
                    if (role[i].factoryId == 0) {
                        this.ischeck = false
                        this.role = role[i]
                        this.scopeDisabled = false
                        this.isclear = true
                        break
                    } else {
                        if (this.userInfo.factoryId == role[i].factoryId) {
                            this.role = role[i]
                        }
                    }
                }
                this.getData()
            },
            onMailUser() {
                if (this.fcIdSelected == undefined || this.fcIdSelected == '') {
                    this.$message.error('请选择工厂！')
                    return
                }
                this.userAndonMailList = []
                this.userMailShow = true
                this.getUserMailList()
            },
            getUserMailList() {
                let params = {}
                this.userSelected = ''
                if (this.fcIdSelected != undefined && this.fcIdSelected != '') {
                    params['fcCode'] = JSON.parse(this.fcIdSelected).deptCode
                }
                params['ampcType'] = 'check'
                let options = {
                    method: 'get',
                    url: this.$api.userMailList,
                    params: params
                }
                this.$http.request(options).then(response => {
                    if (response.status == 100) {
                        if (response.data != undefined && response.data != '') {
                            this.userMailList = response.data
                        } else {
                            this.userMailList = []
                        }
                        this.getAndonMailPushConfigList()
                        this.getWorkShopList()
                    }
                })
            },
            getAndonMailPushConfigList() {
                let params = {}
                if (this.fcIdSelected != undefined && this.fcIdSelected != '') {
                    params['fcCode'] = JSON.parse(this.fcIdSelected).deptCode
                }
                params['ampcType'] = 'check'
                let options = {
                    method: 'get',
                    url: this.$api.AndonMailPushConfigList,
                    params: params
                }
                this.$http.request(options).then(response => {
                    this.userListToSelect = JSON.parse(JSON.stringify(this.userMailList))
                    if (response.data != undefined && response.data != '') {
                        if (response.status == 100 && response.data.length > 0) {
                            this.userAndonMailList = response.data
                            this.userAndonMailList.forEach(mail => {
                                for (var i = this.userListToSelect.length - 1; i >= 0; i--) {
                                    if (this.userListToSelect[i].userId == mail.pushUser)
                                        this.userListToSelect.splice(i, 1)
                                }
                            })
                        }
                    } else {
                        this.userAndonMailList = []
                    }
                })
            },
            getWorkShopList() {
                let params = {}
                this.workSelected = []
                if (this.fcIdSelected != undefined && this.fcIdSelected != '') {
                    params['fcCode'] = JSON.parse(this.fcIdSelected).deptCode
                }
                let options = {
                    method: 'get',
                    url: this.$api.getWorkShopList,
                    params: params
                }
                this.$http.request(options).then(response => {
                    if (response.status == 100) {
                        if (response.data != undefined && response.data != '') {
                            this.workShopList = response.data
                        } else {
                            this.workShopList = []
                        }
                    }
                })
            },
            userMailSelect() {
                let flag = true
                let shopCodes = ''
                for (let i = 0; i < this.userListToSelect.length; i++) {
                    if (this.userSelected == this.userListToSelect[i].userId) {
                        if (this.userListToSelect[i].ampcId != undefined && this.userListToSelect[i].ampcId != '') {
                            flag = false
                        }
                    }
                }
                if (!flag) {
                    for (let a0 = 0; a0 < this.userAndonMailList.length; a0++) {
                        if (this.userSelected == this.userAndonMailList[a0].pushUser) {
                            shopCodes = this.userAndonMailList[a0].shopCodes
                        }
                    }
                    this.workSelected = shopCodes.split(',')
                } else {
                    this.workSelected = []
                }
                //强制刷新
                this.$forceUpdate()
            },
            onAndonUserSelectSubmit() {
                let params = {}
                let shopCodes = ''
                let shopNames = ''
                let flag = true
                if (this.userSelected == undefined || this.userSelected == '') {
                    this.$message.error('请选择用户！')
                    return
                }
                if (this.workSelected.length == 0) {
                    this.$message.error('请选择车间！')
                    return
                }
                for (let i = 0; i < this.userListToSelect.length; i++) {
                    if (this.userSelected == this.userListToSelect[i].userId) {
                        if (this.userListToSelect[i].ampcId != undefined && this.userListToSelect[i].ampcId != '') {
                            flag = false
                            params['ampcId'] = this.userListToSelect[i].ampcId
                        }
                    }
                }
                for (let i = 0; i < this.workSelected.length; i++) {
                    for (let j = 0; j < this.workShopList.length; j++) {
                        if (this.workSelected[i] == this.workShopList[j].shopCode) {
                            shopCodes += this.workShopList[j].shopCode + ','
                            shopNames += this.workShopList[j].shopName + ','
                        }
                    }
                }
                shopCodes = shopCodes.substring(0, shopCodes.length - 1)
                shopNames = shopNames.substring(0, shopNames.length - 1)
                if (this.userSelected != undefined && this.userSelected != '') {
                    params['pushUser'] = this.userSelected
                }
                if (this.fcIdSelected != undefined && this.fcIdSelected != '') {
                    params['fcCode'] = JSON.parse(this.fcIdSelected).deptCode
                }
                if (shopCodes != undefined && shopCodes != '') {
                    params['shopCodes'] = shopCodes
                }
                if (shopNames != undefined && shopNames != '') {
                    params['shopNames'] = shopNames
                }
                params['ampcType'] = 'check'
                this.saveAndonMailUserSubmit(params, flag)
            },
            saveAndonMailUserSubmit(params, flag) {
                let options = {
                    method: 'POST',
                    url: flag ? this.$api.addAndonMailPushConfig : this.$api.editAndonMailPushConfig,
                    data: params
                }
                this.$http.request(options).then(response => {
                    if (response.status == 100) {
                        this.userSelected = ''
                        this.workSelected = []
                        this.getAndonMailPushConfigList()
                    } else {
                        this.$message.error(response.message)
                    }
                })
            },
            editUserAndonMail(row) {
                var flag = true
                if (this.userListToSelect.length != 0) {
                    for (let a0 = 0; a0 < this.userListToSelect.length; a0++) {
                        if (row.pushUser == this.userListToSelect[a0].userId) {
                            flag = false
                        }
                    }
                }
                if (flag) {
                    let array = {
                        ampcId: row.ampcId,
                        userId: row.pushUser,
                        userName: row.userName
                    }
                    this.userListToSelect.push(array)
                }
                this.userSelected = row.pushUser
                var shopCodes = row.shopCodes.split(',')
                this.workSelected = shopCodes
            },
            onAndonMailUserDelete(user) {
                this.$confirm('是否确定删除该数据, 是否继续?', '提示', {
                    confirmButtonText: '删除',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$http
                        .request({
                            method: 'POST',
                            headers: { 'content-type': 'application/json' },
                            params: {
                                ampcId: user.ampcId
                            },
                            url: this.$api.delAndonMailPushConfig
                        })
                        .then(response => {
                            this.getUserMailList()
                            if(response.status == 100) {
                                this.$message.success("删除成功");
                            }
                        })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消删除",
                    });
                });
            },
            paginationChange(val) {
                this.searchParams.pageSize = val
                this.searchTable()
            },
            paginationCurrentChange(val) {
                this.searchParams.page = val
                this.searchTable()
            },
            fcChange: function() {
                this.shopSelected = ''
                this.sectionSelected = ''
                this.lineSelected = ''
                // this.getData();
                this.searchTable()
            },
            shopChange: function() {
                this.sectionSelected = ''
                this.lineSelected = ''
                // this.getData();
                this.searchTable()
            },
            sectionChange: function() {
                this.lineSelected = ''
                // this.getData();
                this.searchTable()
            },
            lineChange: function() {
                // this.getData();
                this.searchTable()
            },
            //跳转工单详情页
            daliyCheckEditor(row) {
                this.$router.push({
                    name: 'dailyCheckDetail',
                    params: {
                        checkDetail: row
                    }
                })
            },
            deleteDaliyCheck(row) {
                this.$confirm('是否确定删除该数据, 是否继续?', '提示', {
                    confirmButtonText: '删除',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
                    .then(() => {
                        this.$http
                            .request({
                                method: 'GET',
                                url: this.$api.deleteDailyCheckOrder,
                                params: { dcoId: row.dcoId }
                            })
                            .then(response => {
                                this.searchTable()
                                // this.$message.success(response.message);
                            })
                            .catch(err => {
                                this.searchTable()
                                // this.$message.error(err);
                            })
                    })
                    .catch(() => {
                        this.searchTable()
                        this.$message({
                            type: 'info',
                            message: '已取消删除'
                        })
                    })
            },
            searchTable() {
                let queryParams = {
                    pageSize: this.searchParams.pageSize,
                    pageNum: this.searchParams.page
                }
                var self = this
                if (self.fcIdSelected != undefined && self.fcIdSelected != '') {
                    queryParams['fcCode'] = JSON.parse(self.fcIdSelected).deptCode
                }
                if (self.shopSelected != undefined && self.shopSelected != '') {
                    queryParams['shopCode'] = JSON.parse(self.shopSelected).deptCode
                }
                if (self.sectionSelected != undefined && self.sectionSelected != '') {
                    queryParams['sectionCode'] = JSON.parse(self.sectionSelected).deptCode
                }
                if (self.lineSelected != undefined && self.lineSelected != '') {
                    queryParams['lineCode'] = JSON.parse(self.lineSelected).deptCode
                }
                if (self.devCode != undefined && self.devCode != '') {
                    queryParams['devCode'] = self.devCode
                }
                if (self.devName != undefined && self.devName != '') {
                    queryParams['devName'] = self.devName
                }
                if (self.dcoId != undefined && self.dcoId != '') {
                    queryParams['dcoId'] = self.dcoId
                }
                if (self.dateRange != null && self.dateRange != '') {
                    if (self.dateRange.length > 0 && self.dateRange[0] != '') {
                        queryParams['startTime'] = self.dateFormat(self.dateRange[0]) + ' 00:00:00'
                        queryParams['endTime'] = self.dateFormat(self.dateRange[1]) + ' 23:59:59'
                    }
                }
                let options = {
                    method: 'GET',
                    params: queryParams,
                    url: this.$api.getAllDailyCheckOrder
                }
                this.$http.request(options).then(response => {
                    if (response.status == 100) {
                        this.tableData = response.data.data.list
                        this.searchParams.pageCount = response.data.total
                    }
                })
            },
            async exportDailyCheckOrder() {
                let queryParams = {}
                var self = this
                if (self.fcIdSelected != undefined && self.fcIdSelected != '') {
                    queryParams['fcCode'] = JSON.parse(self.fcIdSelected).deptCode
                }
                if (self.shopSelected != undefined && self.shopSelected != '') {
                    queryParams['shopCode'] = JSON.parse(self.shopSelected).deptCode
                }
                if (self.sectionSelected != undefined && self.sectionSelected != '') {
                    queryParams['sectionCode'] = JSON.parse(self.sectionSelected).deptCode
                }
                if (self.lineSelected != undefined && self.lineSelected != '') {
                    queryParams['lineCode'] = JSON.parse(self.lineSelected).deptCode
                }
                if (self.devCode != undefined && self.devCode != '') {
                    queryParams['devCode'] = self.devCode
                }
                if (self.devName != undefined && self.devName != '') {
                    queryParams['devName'] = self.devName
                }
                if (self.dcoId != undefined && self.dcoId != '') {
                    queryParams['dcoId'] = self.dcoId
                }
                if (self.dateRange != null && self.dateRange != '') {
                    if (self.dateRange.length > 0 && self.dateRange[0] != '') {
                        queryParams['startTime'] = self.dateFormat(self.dateRange[0]) + ' 00:00:00'
                        queryParams['endTime'] = self.dateFormat(self.dateRange[1]) + ' 23:59:59'
                    }
                }
                let options = {
                    url: this.$api.exportDailyCheckOrder,
                    method: 'POST',
                    params: queryParams,
                    responseType: 'blob',
                    headers: {
                        'Content-Type': 'application/json;application/ms-excel;application/ms-excel;charset=utf-8'
                    }
                }
                this.$http.config.timeout = 60000
                let result = await this.$http.request(options)
                var elink = document.createElement('a')
                elink.download = '设备点检信息'  //设置名称
                elink.style.display = 'none'
                var blob = new Blob([result], { type: 'application/vnd.ms-excel' })
                elink.href = URL.createObjectURL(blob)
                document.body.appendChild(elink)  //追加节点
                elink.click()
                document.body.removeChild(elink)  //删除节点
            },
            getData() {
                var self = this
                let options = {
                    method: 'GET',
                    url: this.$api.departTree
                }
                this.$http.request(options).then(response => {
                    this.factoryTree = response.data
                    for (var i = 0; i < self.factoryTree.length; i++) {
                        if (self.factoryTree[i].deptID == self.role.factoryId) {
                            self.fcIdSelected = JSON.stringify(self.factoryTree[i])
                        }
                        if (self.$route.params.daiExamine != undefined && self.$route.params.daiExamine != '') {
                            self.dailyArray = self.$route.params.daiExamine
                            if (self.dailyArray.hasOwnProperty('fcCode')) {
                                if (self.factoryTree[i].deptCode == self.dailyArray.fcCode) {
                                    self.fcIdSelected = JSON.stringify(self.factoryTree[i])
                                    if (self.dailyArray.hasOwnProperty('shopCode')) {
                                        var shops = JSON.parse(self.fcIdSelected).child
                                        for (let j = 0; j < shops.length; j++) {
                                            if (shops[j].hasOwnProperty('deptCode')) {
                                                if (shops[j].deptCode == self.dailyArray.shopCode) {
                                                    self.shopSelected = JSON.stringify(shops[j])
                                                    if (self.dailyArray.hasOwnProperty('sectionCode')) {
                                                        var sections = JSON.parse(self.shopSelected).child
                                                        for (let k = 0; k < sections.length; k++) {
                                                            if (sections[k].hasOwnProperty('deptCode')) {
                                                                if (sections[k].deptCode == self.dailyArray.sectionCode) {
                                                                    self.sectionSelected = JSON.stringify(sections[k])
                                                                    if (self.dailyArray.hasOwnProperty('lineCode')) {
                                                                        var lines = JSON.parse(self.sectionSelected).child
                                                                        for (let l = 0; l < lines.length; l++) {
                                                                            if (lines[l].hasOwnProperty('deptCode')) {
                                                                                if (lines[l].deptCode == self.dailyArray.lineCode) {
                                                                                    self.lineSelected = JSON.stringify(lines[l])
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                    if (self.$route.params.daiExamine != undefined && self.$route.params.daiExamine != '') {
                        self.devCode = self.dailyArray.devCode
                        self.devName = self.dailyArray.devName
                        self.dcoId = self.dailyArray.dcoId
                    }
                    this.searchTable()
                })
            },
            dateFormat(date) {
                return moment(date).format('YYYY-MM-DD')
            }
        }
    }
</script>

<style scoped>
</style>
